module.exports = __webpack_public_path__ + "img/teachersZoomConvertido.830e5d2e.webp";